import { FC, memo, useMemo } from "react";
import styles from "./LikeButton.module.css";

import { Button, ButtonProps, Space } from "antd";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMutation, useQueryClient } from "react-query";
import {
  likeProjectRequest,
  dislikeProjectRequest,
  IProject,
} from "api/project";
import { useUser } from "api/auth";
import clsx from "clsx";

type LikeButtonProps = Partial<ButtonProps> & {
  project: IProject;
  className?: string;
};

const LikeButton: FC<LikeButtonProps> = ({ project, className }) => {
  const queryClient = useQueryClient();
  const { data: me } = useUser({ enabled: false });
  const { mutate: like } = useMutation(likeProjectRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(["project", project._id]);
    },
  });
  const { mutate: dislike } = useMutation(dislikeProjectRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(["project", project._id]);
    },
  });

  const isLiked = useMemo(() => {
    return project.likes.findIndex((x) => x._id === me?._id) !== -1;
  }, [project, me]);

  const handleLike = () => {
    isLiked ? dislike(project._id) : like(project._id);
  };

  return (
    <Button
      onClick={handleLike}
      size="large"
      className={clsx(styles.btnLike, !isLiked && styles.btnDefault, className)}
    >
      <Space align="baseline">
        <div>
          <FontAwesomeIcon
            className="mr-8"
            color={isLiked ? "#DF3535" : "rgba(255,255,255,0.7)"}
            icon={faHeart}
          />
          {isLiked ? "Liked" : "Like"}
        </div>
        {project.likes && project.likes.length > 0 && (
          <span className={styles.likeCount}>{project.likes.length}</span>
        )}
      </Space>
    </Button>
  );
};

export default memo(LikeButton);
